<template>
  <div class="row">
    <div class="col-lg">
      <br />
      <br />


      <!-- <div class="row">
        <div class="col-lg-3 text-left" v-if="positionid != 2">
          <el-select placeholder="Select Port" v-model="selects.port" filterable @change="getData()">
            <el-option v-for="option in selects.ports" class="select-info custom-option" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div  class="col-lg text-left">
          <div style="display: flex;" v-if="flag != 'sales'" >
            <el-date-picker  style="flex-grow: 50%;" placeholder="Select Date" v-model="selects.date" type="daterange" range-separator="To"
              start-placeholder="Start date" end-placeholder="End date" @change="getData()">
            </el-date-picker>
          </div>
          <div v-if="flag == 'sales'">
            <el-date-picker placeholder="Select Year" v-model="selects.date" type="year" @change="getData()">
            </el-date-picker>
          </div>
        </div>
        <div class="col-lg"></div>
      </div> -->

      <div class="d-flex flex-row flex-wrap justify-content-between mx-0 py-2">
        <div class="flex-grow-1 text-left" v-if="positionid != 2">
          <el-select placeholder="Select Port" v-model="selects.port" filterable @change="getData()">
            <el-option v-for="option in selects.ports" class="select-info custom-option" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>

        <div class="w-25 text-left">
          <div v-if="flag != 'sales'">
            <el-date-picker placeholder="Select Date" v-model="selects.date" type="daterange" range-separator="To"
              start-placeholder="Start date" end-placeholder="End date" @change="getData()">
            </el-date-picker>
          </div>
          <div v-if="flag == 'sales'">
            <el-date-picker placeholder="Select Year" v-model="selects.date" type="year" @change="getData()">
            </el-date-picker>
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-lg-12">
          <br />
          <div class="row">
            <div class="col-lg">
              <base-button class="btn-link" @click="tabActive('incoming')" style="font-size: 20px"
                :style="incoming">Incoming</base-button>
            </div>
            <div class="col-lg">
              <base-button class="btn-link" @click="tabActive('preprocessing')" style="font-size: 20px"
                :style="preprocessing">Pre-processing</base-button>
            </div>
            <div class="col-lg">
              <base-button class="btn-link" @click="tabActive('outgoing')" style="font-size: 20px"
                :style="outgoing">Outgoing</base-button>
            </div>
            <div class="col-lg">
              <base-button class="btn-link" @click="tabActive('sales')" style="font-size: 20px"
                :style="sales">Sales</base-button>
            </div>
          </div>
        </div>
      </div> -->

      <div class="d-flex flex-row flex-nowrap justify-content-around mx-0 my-4">
        <base-button class="btn-link" @click="tabActive('incoming')" style="font-size: 20px"
          :style="incoming">Incoming</base-button>
        <base-button class="btn-link" @click="tabActive('preprocessing')" style="font-size: 20px"
          :style="preprocessing">Pre-processing</base-button>
        <base-button class="btn-link" @click="tabActive('outgoing')" style="font-size: 20px"
          :style="outgoing">Outgoing</base-button>
        <base-button class="btn-link" @click="tabActive('sales')" style="font-size: 20px"
          :style="sales">Sales</base-button>
      </div>

      <div class="row" v-if="flag == 'incoming'">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg-4" style="padding-top: 3%">
                        <img src="@/assets/img/Incoming blue.png" width="170" />
                      </div>
                      <div class="col-lg">
                        <p class="text-eprf">
                          Total <br />
                          Job Request
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ totaljobrequest }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg-4" style="padding-top: 3%">
                        <img src="@/assets/img/Incoming green.png" width="170" />
                      </div>
                      <div class="col-lg">
                        <p class="text-eprf">
                          Completed <br />
                          Job Request
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ completedjobrequest }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>

                <div class="col-lg">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg-4" style="padding-top: 3%">
                        <img src="@/assets/img/Incoming orange.png" width="170" />
                      </div>
                      <div class="col-lg">
                        <p class="text-eprf">
                          Pending <br />
                          Job Request
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ pendingjobrequest }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg-4" style="padding-top: 3%">
                        <img src="@/assets/img/Incoming red.png" width="170" />
                      </div>
                      <div class="col-lg">
                        <p class="text-eprf">
                          Overdue <br />
                          Job Request
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ overduejobrequest }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-lg">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg">
                            <p class="card-title">Waste Requested</p>
                            <p style="color: #a3a3a3; font-weight: 400">
                              <i>{{ daterange }}</i>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-10">
                            <div class="chart-area">
                              <line-chart v-if="wastecollected.loaded" :chart-data="wastecollected.chartData"
                                :extra-options="wastecollected.extraOptions" :height="350"></line-chart>
                              <div class="d-flex justify-content-center spinner" v-if="!wastecollected.loaded">
                                <circle-8></circle-8>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg">
                            <div class="row" style="padding-top: 8%">
                              <div class="col-lg">
                                <p class="text-eprf">Total Job Requests</p>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-lg text-center">
                                <h1 class="text-primary">
                                  {{ totalcollection }}
                                </h1>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg">
                                <p style="color: #a5a5a5">
                                  <i class="fa fa-circle" aria-hidden="true" style="color: #32ba7c"></i>
                                  Vessel Generated
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg">
                                <p style="color: #a5a5a5">
                                  <i class="fa fa-circle" aria-hidden="true" style="color: #358CCB"></i>
                                  Land Generated
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </card>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg d-flex">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg">
                            <base-button @click="generateland('total')" class="btn-link" style="font-size: 14px"
                              :style="incominglandpie1">Total</base-button>
                          </div>
                          <div class="col-lg">
                            <base-button @click="generateland('completed')" class="btn-link" style="font-size: 14px"
                              :style="incominglandpie2">Completed</base-button>
                          </div>
                          <div class="col-lg">
                            <base-button @click="generateland('pending')" class="btn-link" style="font-size: 14px"
                              :style="incominglandpie3">Pending</base-button>
                          </div>
                          <div class="col-lg">
                            <base-button @click="generateland('overdue')" class="btn-link" style="font-size: 14px"
                              :style="incominglandpie4">Overdue</base-button>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg-8">
                            <pie-chart v-if="landgenerated.loaded" :chart-data="landgenerated.chartData"
                              :extra-options="landgenerated.extraOptions" :height="250"></pie-chart>
                          </div>
                          <div class="col-lg-4" style="padding-top: 3%">
                            <div class="row" v-for="(item, index) in land" :key="index">
                              <div class="col-lg">
                                <p style="color: #4b4b4b; font-weight: 400">
                                  <i class="fa fa-circle" aria-hidden="true" :style="'color: ' + item.color"></i>
                                  {{ item.title }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </card>
                    </div>
                    <div class="col-lg d-flex">
                      <card class="card-eprf">
                        <div class="row">

                          <div class="col-lg">
                            <base-button @click="generatevessel('completed')" class="btn-link" style="font-size: 14px"
                              :style="incomingvesselpie2">Completed</base-button>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg-8">
                            <pie-chart v-if="vesselgenerated.loaded" :chart-data="vesselgenerated.chartData"
                              :extra-options="vesselgenerated.extraOptions" :height="250"></pie-chart>
                          </div>
                          <div class="col-lg-4" style="">
                            <div class="row" v-for="(item, index) in vessel" :key="index">
                              <div class="col-lg">
                                <p style="color: #4b4b4b; font-weight: 400">
                                  <i class="fa fa-circle" aria-hidden="true" :style="'color: ' + item.color"></i>
                                  {{ item.title }}
                                  <br />
                                  <span style="color: #a9a9a9; font-size: 12px">{{ item.subtitle }}</span>
                                  <br />
                                  <span style="color: #a9a9a9; font-size: 12px">{{ item.subtitle2 }}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </card>
                    </div>
                    <!-- <div class="col-lg-3 d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="text-eprf">Total Annex Collected</p>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-for="(item, index) in total5annexcollected"
                      :key="index"
                    >
                      <div class="col-lg-2" style="padding-top: 3%">
                        <base-button class="btn-icon btn-round btn-sm">{{
                          index + 1
                        }}</base-button>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #a5a5a5">{{ item.name }}</p>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #3495c6">
                          {{ item.total }} MT
                        </p>
                      </div>
                    </div>
                  </card>
                </div> -->
                  </div>
                </div>
                <div class="col-lg-3 d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="text-eprf">Top 15 SW Collected</p>
                      </div>
                    </div>
                    <div class="row" v-for="(item, index) in total5swcollected" :key="index">
                      <div class="col-lg-2" style="padding-top: 3%">
                        <base-button class="btn-icon btn-round btn-sm">{{
                          index + 1
                        }}</base-button>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #a5a5a5">{{ item.name }}</p>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #3495c6">
                          {{ item.total }} MT
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="flag == 'preprocessing'">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg d-flex">
                  <card class="card-eprf">
                    <div class="row" style="">
                      <div class="col-lg-4" style="padding-left: 12%; padding-top: 3%">
                        <img src="@/assets/img/pp-yellow.png" width="110" />
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="text-eprf">
                          Total Job <br />
                          in Progress
                        </p>
                        <!-- <p class="text-eprf">
                              Total Item Assigned<br />
                              in Pre-processing
                            </p> -->
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ totaljobinprogress }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg d-flex">
                  <card class="card-eprf">
                    <div class="row" style="">
                      <div class="col-lg-4" style="padding-left: 12%; padding-top: 3%">
                        <img src="@/assets/img/pp-green.png" width="110" />
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="text-eprf">
                          Total Job<br />
                          Completed
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ totaljobcompleted }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg d-flex">
                  <card class="card-eprf">
                    <div class="row" style="">
                      <div class="col-lg-4" style="padding-left: 12%; padding-top: 3%">
                        <img src="@/assets/img/pp-blue.png" width="110" />
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="text-eprf">Total Job<br /><br /></p>

                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ totaljob }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="card-title">Oil Produced</p>
                        <p style="color: #a3a3a3; font-weight: 400">
                          <i>{{ daterange }}</i>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-10">
                        <div class="chart-area">
                          <line-chart v-if="oilcollected.loaded" :chart-data="oilcollected.chartData"
                            :extra-options="oilcollected.extraOptions" :height="350"></line-chart>
                          <div class="d-flex justify-content-center spinner" v-if="!oilcollected.loaded">
                            <circle-8></circle-8>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg">
                        <div class="row" style="padding-top: 8%">
                          <div class="col-lg">
                            <p class="text-eprf">Total Collection</p>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg">
                            <h1 class="text-primary">
                              {{ totalcollection }}
                            </h1>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #a5a5a5">
                              <i class="fa fa-circle" aria-hidden="true" style="color: #32ba7c"></i>
                              Sellable
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #a5a5a5">
                              <i class="fa fa-circle" aria-hidden="true" style="color: #358CCB"></i>
                              Non-sellable
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg-4 d-flex">
                  <card class="card-eprf">
                    <br />
                    <br />
                    <div class="row">
                      <div class="col-lg">
                        <pie-chart v-if="oilproducts.loaded" :chart-data="oilproducts.chartData"
                          :extra-options="oilproducts.extraOptions" :height="250"></pie-chart>
                      </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <div class="row">
                      <div class="col-lg"></div>
                      <div class="col-lg-6" style="padding-top: 3%">
                        <div class="row" v-for="(item, index) in oil" :key="index">
                          <div class="col-lg">
                            <p style="color: #4b4b4b; font-weight: 400">
                              <i class="fa fa-circle" aria-hidden="true" :style="'color: ' + item.color"></i>
                              {{ item.title }}
                            </p>
                            <br />
                          </div>
                        </div>
                      </div>
                      <div class="col-lg"></div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="text-eprf">Top 5 Sellable</p>
                      </div>
                    </div>
                    <div class="row" v-for="(item, index) in top5sellable" :key="index">
                      <div class="col-lg-2" style="padding-top: 3%">
                        <base-button class="btn-icon btn-round btn-sm">{{
                          index + 1
                        }}</base-button>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #a5a5a5">{{ item.name }}</p>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #3495c6">
                          {{ item.total }} MT
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="text-eprf">Top 5 Non-sellable</p>
                      </div>
                    </div>
                    <div class="row" v-for="(item, index) in top5nonsellable" :key="index">
                      <div class="col-lg-2" style="padding-top: 3%">
                        <base-button class="btn-icon btn-round btn-sm">{{
                          index + 1
                        }}</base-button>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #a5a5a5">{{ item.name }}</p>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #3495c6">
                          {{ item.total }} MT
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-lg-9 d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="card-title">Waste Collected</p>
                        <p style="color: #a3a3a3; font-weight: 400">
                          <i>{{ daterange }}</i>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-10">
                        <div class="chart-area">
                          <line-chart
                            :chart-data="wastecollected.chartData"
                            :extra-options="wastecollected.extraOptions"
                            :height="350"
                          ></line-chart>
                          <div
                            class="d-flex justify-content-center spinner"
                            v-if="!wastecollected.loaded"
                          >
                            <circle-8></circle-8>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg">
                        <div class="row" style="padding-top: 8%">
                          <div class="col-lg">
                            <p class="text-eprf">Total Collection</p>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg">
                            <h1 class="text-primary">{{ totalcollection }}</h1>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #a5a5a5">
                              <i
                                class="fa fa-circle"
                                aria-hidden="true"
                                style="color: #32ba7c"
                              ></i>
                              Vessel Generated
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #a5a5a5">
                              <i
                                class="fa fa-circle"
                                aria-hidden="true"
                                style="color: #358CCB"
                              ></i>
                              Land Generated
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg-3 d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="text-eprf">Top 5 SW Collected</p>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-for="(item, index) in total5swcollected"
                      :key="index"
                    >
                      <div class="col-lg-2" style="padding-top: 3%">
                        <base-button class="btn-icon btn-round btn-sm">{{
                          index + 1
                        }}</base-button>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #a5a5a5">{{ item.name }}</p>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #3495c6">
                          {{ item.total }} MT
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg d-flex">
                  <card class="card-eprf">
                    <br />
                    <br />
                    <div class="row">
                      <div class="col-lg-8">
                        <pie-chart
                          v-if="landgenerated.loaded"
                          :chart-data="landgenerated.chartData"
                          :extra-options="landgenerated.extraOptions"
                          :height="250"
                        ></pie-chart>
                      </div>
                      <div class="col-lg-4" style="padding-top: 3%">
                        <div
                          class="row"
                          v-for="(item, index) in land"
                          :key="index"
                        >
                          <div class="col-lg">
                            <p style="color: #4b4b4b; font-weight: 400">
                              <i
                                class="fa fa-circle"
                                aria-hidden="true"
                                :style="'color: ' + item.color"
                              ></i>
                              {{ item.title }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg d-flex">
                  <card class="card-eprf">
                    <br />
                    <br />
                    <div class="row">
                      <div class="col-lg-8">
                        <pie-chart
                          v-if="vesselgenerated.loaded"
                          :chart-data="vesselgenerated.chartData"
                          :extra-options="vesselgenerated.extraOptions"
                          :height="250"
                        ></pie-chart>
                      </div>
                      <div class="col-lg-4" style="">
                        <div
                          class="row"
                          v-for="(item, index) in vessel"
                          :key="index"
                        >
                          <div class="col-lg">
                            <p style="color: #4b4b4b; font-weight: 400">
                              <i
                                class="fa fa-circle"
                                aria-hidden="true"
                                :style="'color: ' + item.color"
                              ></i>
                              {{ item.title }}
                              <br />
                              <span style="color: #a9a9a9; font-size: 12px">{{
                                item.subtitle
                              }}</span>
                              <br />
                              <span style="color: #a9a9a9; font-size: 12px">{{
                                item.subtitle2
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg-3 d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="text-eprf">Total Annex Collected</p>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-for="(item, index) in total5annexcollected"
                      :key="index"
                    >
                      <div class="col-lg-2" style="padding-top: 3%">
                        <base-button class="btn-icon btn-round btn-sm">{{
                          index + 1
                        }}</base-button>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #a5a5a5">{{ item.name }}</p>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #3495c6">
                          {{ item.total }} MT
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="flag == 'outgoing'">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg-4" style="padding-top: 3%">
                        <img src="@/assets/img/Outgoing Total Job.png" width="170" />
                      </div>
                      <div class="col-lg">
                        <p class="text-eprf">
                          Total <br />
                          Job Created
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ totaljobcreated }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg-4" style="padding-top: 3%">
                        <img src="@/assets/img/Outgoing Total Job.png" width="170" />
                      </div>
                      <div class="col-lg">
                        <p class="text-eprf">
                          Total <br />
                          Job Accepted
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ totaljobaccepted }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>

                <div class="col-lg">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg-4" style="padding-top: 3%">
                        <img src="@/assets/img/Outgoing Job Completed.png" width="170" />
                      </div>
                      <div class="col-lg">
                        <p class="text-eprf">
                          Total <br />
                          Job Completed
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ totaljobcomplete }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
                <div class="col-lg">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg-4" style="padding-top: 3%">
                        <img src="@/assets/img/Outgoing Job Pending.png" width="170" />
                      </div>
                      <div class="col-lg">
                        <p class="text-eprf">
                          Total <br />
                          Job Pending
                        </p>
                        <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                          {{ overduejob }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-lg">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg">
                            <p class="card-title">Waste Disposed</p>
                            <p style="color: #a3a3a3; font-weight: 400">
                              <i>{{ daterange }}</i>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-10">
                            <div class="chart-area">
                              <line-chart v-if="wastesdisposed.loaded" :chart-data="wastesdisposed.chartData"
                                :extra-options="wastesdisposed.extraOptions" :height="350"></line-chart>
                              <div class="d-flex justify-content-center spinner" v-if="!wastesdisposed.loaded">
                                <circle-8></circle-8>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg">
                            <div class="row" style="padding-top: 8%">
                              <div class="col-lg">
                                <p class="text-eprf">Total Disposal</p>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-lg text-center">
                                <h1 class="text-primary">
                                  {{ totaldisposal }}
                                </h1>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg">
                                <p style="color: #a5a5a5">
                                  <i class="fa fa-circle" aria-hidden="true" style="color: #358CCB"></i>
                                  Waste
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </card>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="text-eprf">Top 15 Waste Disposed</p>
                      </div>
                    </div>
                    <div class="row" v-for="(item, index) in top5wastes" :key="index">
                      <div class="col-lg-2" style="padding-top: 3%">
                        <base-button class="btn-icon btn-round btn-sm">{{
                          index + 1
                        }}</base-button>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #a5a5a5">{{ item.name }}</p>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #3495c6">
                          {{ item.total }} MT
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="flag == 'sales'">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-lg">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg-4" style="padding-top: 3%">
                            <img src="@/assets/img/Total Sales 1.png" width="170" />
                          </div>
                          <div class="col-lg">
                            <p class="text-eprf">
                              Total Sales
                            </p>
                            <p class="text-primary" style="font-size: clamp(1rem, 10vw, 2rem)">
                              RM {{ totalsales }}
                            </p>
                          </div>
                        </div>
                      </card>
                    </div>
                    <div class="col-lg">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg-4" style="padding-top: 3%">
                            <img src="@/assets/img/Sales Target 1.png" width="170" />
                          </div>
                          <div class="col-lg">
                            <p class="text-eprf">
                              Monthly <br />
                              Sales Target
                            </p>
                            <p class="text-primary" style="font-size: clamp(0.5rem, 5vw, 1rem)">
                              RM {{ monthlysalestarget }}
                              <span class="text-eprf">/ RM{{ totalmonthlysalestarget }}</span>
                            </p>
                          </div>
                        </div>
                      </card>
                    </div>
                    <div class="col-lg">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg-4" style="padding-top: 3%">
                            <img src="@/assets/img/Sales Target 1.png" width="170" />
                          </div>
                          <div class="col-lg">
                            <p class="text-eprf">
                              Quarterly <br />
                              Sales Target
                            </p>
                            <p class="text-primary" style="font-size: clamp(0.5rem, 5vw, 1rem)">
                              RM {{ quarterlysalestarget }}
                              <span class="text-eprf">/ RM{{ totalquarterlysalestarget }}</span>
                            </p>
                          </div>
                        </div>
                      </card>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg">
                            <p class="card-title">Total Monthly Sales</p>
                            <p style="color: #a3a3a3; font-weight: 400">
                              <i>{{ daterange }}</i>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-10">
                            <div class="chart-area">
                              <line-chart v-if="salescollected.loaded" :chart-data="salescollected.chartData"
                                :extra-options="salescollected.extraOptions" :height="350"></line-chart>
                              <div class="d-flex justify-content-center spinner" v-if="!salescollected.loaded">
                                <circle-8></circle-8>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg">
                            <div class="row" style="padding-top: 8%">
                              <div class="col-lg">
                                <p class="text-eprf">Total Sales</p>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-lg text-center">
                                <h1 class="text-primary">
                                  RM {{ totalsales }}
                                </h1>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg">
                                <p style="color: #a5a5a5">
                                  <i class="fa fa-circle" aria-hidden="true" style="color: #358CCB"></i>
                                  Sales
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </card>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 d-flex">
                  <card class="card-eprf">
                    <div class="row">
                      <div class="col-lg">
                        <p class="text-eprf">Top 10 Product Requested</p>
                      </div>
                    </div>
                    <div class="row" v-for="(item, index) in top10sales" :key="index">
                      <div class="col-lg-2" style="padding-top: 3%">
                        <base-button class="btn-icon btn-round btn-sm">{{
                          index + 1
                          }}</base-button>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #a5a5a5">{{ item.name }}</p>
                      </div>
                      <div class="col-lg" style="padding-top: 3%">
                        <p class="" style="color: #3495c6">
                          RM {{ item.total }}
                        </p>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from "element-ui";
import moment from "moment";

import Loading from "vue-loading-overlay";
import { Circle8 } from "vue-loading-spinner";
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import PieChart from "src/components/Charts/PieChart";
import util from "src/util/util"

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    LineChart,
    Loading,
    Circle8,
    PieChart,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      formattedDate: '',
      month: '',
      quarter: '',

      positionid: 0,
      selects: {
        port: "",
        ports: [],
        date: "",
      },
      incoming: "color: #358CCB ",
      incominglandpie1: "color: #358CCB ",
      incominglandpie2: "color: #000000 ",
      incominglandpie3: "color: #000000 ",
      incominglandpie4: "color: #000000 ",
      incomingvesselpie1: "color: #000000 ",
      incomingvesselpie2: "color: #358CCB ",
      incomingvesselpie3: "color: #000000 ",
      incomingvesselpie4: "color: #000000 ",
      preprocessing: "color: #000000",
      outgoing: "color: #000000",
      sales: "color: #000000",
      flag: "",
      landflag: "total",
      vesselflag: "completed",
      total: {},
      completed: {},
      pending: {},
      overdue: {},
      total2: {},
      completed2: {},
      pending2: {},
      overdue2: {},
      totaljobrequest: "0",
      totaljobcreated: 0,
      totaljobaccepted: 0,
      totaljobcomplete: 0,
      overduejob: 0,
      totalsales: 0,
      monthlysalestarget: 0,
      quarterlysalestarget: 0,
      totalmonthlysalestarget: 0,
      totalquarterlysalestarget: 0,
      completedjobrequest: "0",
      pendingjobrequest: "0",
      overduejobrequest: "0",
      daterange: "Jan - Dec 2023",
      wastecollected: {
        chartData: {
          labels: [],
          datasets: [
            {
              yAxisID: "y-axis-1",
              type: "line",
              label: "Vessel Generated",
              fill: false,
              borderColor: "#32BA7C",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.5,
              pointBackgroundColor: "#32BA7C",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#32BA7C",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [],
            },
            {
              yAxisID: "y-axis-2",
              type: "line",
              label: "Land Generated",
              fill: false,
              borderColor: "#358CCB",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#358CCB",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#358CCB",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.purpleChartOptionslll,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 1, 1],
      },
      totalcollection: "0",
      totaldisposal: 0,
      total5swcollected: [
        // {
        //   name: "sw",
        //   total: 5,
        // },
        // {
        //   name: "sw",
        //   total: 5,
        // },
        // {
        //   name: "sw",
        //   total: 5,
        // },
        // {
        //   name: "sw",
        //   total: 5,
        // },
        // {
        //   name: "sw",
        //   total: 5,
        // },
      ],
      total5annexcollected: [
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
      ],
      landgenerated: {
        chartData: {
          // "Scheduled Waste", "Garbage", "Sewage", "Scrap", "Others"
          labels: [],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: [
                "#3495C6",
                "#33BBB7",
                "#33A02C",
                "#C1C1C1",
                "#EBEBEB",
              ],
              borderWidth: 0,
              // 35, 20, 5, 30, 10
              data: [],
            },
          ],
        },
        loaded: false,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: "right",
            labels: {
              usePointStyle: true,
              pointStyle: {
                margin: "10px",
              },
              boxWidth: 10,
              fontColor: "white",
            },
          },
          elements: {
            center: {
              text: "",
              //   color: "#000000", // Default is #000000
              fontStyle: "Poppins", // Default is Arial
              sidePadding: 20, // Default is 20 (as a percentage)
              minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
              lineHeight: 30, // Default is 25 (in px), used for when text wraps
            },
          },
          responsive: true,
          cutoutPercentage: 80,
          tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
          },
          animation: {
            duration: 500,
            onProgress: function (chart) {
              if (chart.chart.config.options.elements.center) {
                // Get ctx from string
                var ctx = chart.chart.ctx;

                // Get options from the center object in options
                var centerConfig = chart.chart.config.options.elements.center;
                var fontStyle = centerConfig.fontStyle || "Poppins";
                var txt = centerConfig.text;
                var color = centerConfig.color || "#000000";
                var maxFontSize = centerConfig.maxFontSize || 75;
                var sidePadding = centerConfig.sidePadding || 20;
                var sidePaddingCalculated =
                  (sidePadding / 100) * (chart.innerRadius * 2);
                // Start with a base font of 30px
                ctx.font = "20px " + fontStyle;

                // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                var stringWidth = ctx.measureText(txt).width;
                var elementWidth =
                  chart.innerRadius * 2 - sidePaddingCalculated;

                // Find out how much the font can grow in width.
                var widthRatio = elementWidth / stringWidth;
                var newFontSize = Math.floor(30 * widthRatio);
                var elementHeight = chart.innerRadius * 2;

                // Pick a new font size so it will not be larger than the height of label.
                var fontSizeToUse = Math.min(
                  newFontSize,
                  elementHeight,
                  maxFontSize
                );
                var minFontSize = centerConfig.minFontSize;
                var lineHeight = centerConfig.lineHeight || 25;
                var wrapText = false;

                if (minFontSize === undefined) {
                  minFontSize = 20;
                }

                if (minFontSize && fontSizeToUse < minFontSize) {
                  fontSizeToUse = minFontSize;
                  wrapText = true;
                }

                // Set font settings to draw it correctly.
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                var centerX =
                  (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                  2;
                var centerY =
                  (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                  2;
                ctx.font = fontSizeToUse + "px " + fontStyle;
                ctx.fillStyle = color;

                //Draw text in center
                ctx.font = " 20px Poppins, sans-serif";
                ctx.fillStyle = "#000000";
                ctx.fillText("Land", centerX, centerY - 10);
                ctx.fillText("Generated", centerX, centerY + 15);
              }
            },
          },

          scales: {
            yAxes: [
              {
                display: 0,
                ticks: {
                  display: false,
                },
                gridLines: {
                  drawBorder: false,
                  zeroLineColor: "transparent",
                  color: "rgba(255,255,255,0.05)",
                },
              },
            ],

            xAxes: [
              {
                display: 0,
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(255,255,255,0.1)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      vesselgenerated: {
        chartData: {
          // "Scheduled Waste", "Garbage", "Sewage", "Scrap", "Others"
          labels: [],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: [
                "#3495C6",
                "#33BBB7",
                "#33A02C",
                "#C1C1C1",
                "#EBEBEB",
              ],
              borderWidth: 0,
              // 35, 20, 5, 30, 10
              data: [],
            },
          ],
        },
        loaded: false,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: "right",
            labels: {
              usePointStyle: true,
              pointStyle: {
                margin: "10px",
              },
              boxWidth: 10,
              fontColor: "black",
            },
          },
          elements: {
            center: {
              text: "",
              color: "#000000", // Default is #000000
              fontStyle: "Poppins", // Default is Arial
              sidePadding: 20, // Default is 20 (as a percentage)
              minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
              lineHeight: 30, // Default is 25 (in px), used for when text wraps
            },
          },
          responsive: true,
          cutoutPercentage: 80,
          tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
          },
          animation: {
            duration: 500,
            onProgress: function (chart) {
              if (chart.chart.config.options.elements.center) {
                // Get ctx from string
                var ctx = chart.chart.ctx;

                // Get options from the center object in options
                var centerConfig = chart.chart.config.options.elements.center;
                var fontStyle = centerConfig.fontStyle || "Poppins";
                var txt = centerConfig.text;
                var color = centerConfig.color || "#000000";
                var maxFontSize = centerConfig.maxFontSize || 75;
                var sidePadding = centerConfig.sidePadding || 20;
                var sidePaddingCalculated =
                  (sidePadding / 100) * (chart.innerRadius * 2);
                // Start with a base font of 30px
                ctx.font = "20px " + fontStyle;

                // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                var stringWidth = ctx.measureText(txt).width;
                var elementWidth =
                  chart.innerRadius * 2 - sidePaddingCalculated;

                // Find out how much the font can grow in width.
                var widthRatio = elementWidth / stringWidth;
                var newFontSize = Math.floor(30 * widthRatio);
                var elementHeight = chart.innerRadius * 2;

                // Pick a new font size so it will not be larger than the height of label.
                var fontSizeToUse = Math.min(
                  newFontSize,
                  elementHeight,
                  maxFontSize
                );
                var minFontSize = centerConfig.minFontSize;
                var lineHeight = centerConfig.lineHeight || 25;
                var wrapText = false;

                if (minFontSize === undefined) {
                  minFontSize = 20;
                }

                if (minFontSize && fontSizeToUse < minFontSize) {
                  fontSizeToUse = minFontSize;
                  wrapText = true;
                }

                // Set font settings to draw it correctly.
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                var centerX =
                  (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                  2;
                var centerY =
                  (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                  2;
                ctx.font = fontSizeToUse + "px " + fontStyle;
                ctx.fillStyle = color;

                //Draw text in center
                ctx.font = " 20px Poppins, sans-serif";
                ctx.fillStyle = "#000000";
                ctx.fillText("Vessel", centerX, centerY - 10);
                ctx.fillText("Generated", centerX, centerY + 15);
              }
            },
          },

          scales: {
            yAxes: [
              {
                display: 0,
                ticks: {
                  display: false,
                },
                gridLines: {
                  drawBorder: false,
                  zeroLineColor: "transparent",
                  color: "rgba(255,255,255,0.05)",
                },
              },
            ],

            xAxes: [
              {
                display: 0,
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(255,255,255,0.1)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      land: [
        {
          title: "Scheduled Waste",
          color: "#3495C6",
        },
        {
          title: "Garbage",
          color: "#33BBB7",
        },
        {
          title: "Tyre",
          color: "#82ba41",
        },
        {
          title: "Scrap",
          color: "#c1c1c1",
        },
        // {
        //   title: "Others",
        //   color: "#ffffff; border: 0.5px solid #c1c1c1; border-radius: 50%",
        // },
      ],
      vessel: [
        {
          title: "Annex I",
          subtitle: "Oil mixture",
          subtitle2: "",

          color: "#3495C6",
        },
        {
          title: "Annex II",
          subtitle: "Noxious Liquid ",
          subtitle2: "Substances (NLS)",

          color: "#33BBB7",
        },
        {
          title: "Annex IV",
          subtitle: "Sewage",
          subtitle2: "",
          color: "#82ba41",
        },
        {
          title: "Annex V",
          subtitle: "Garbage",
          subtitle2: "",
          color: "#c1c1c1",
        },
        {
          title: "Annex VI",
          subtitle: "Ozone Depleting",
          subtitle2: "Substances",
          color: "#ffffff; border: 0.5px solid #c1c1c1; border-radius: 50%",
        },
      ],
      // preprocessing
      totaljobinprogress: 0,
      totaljobcompleted: 0,
      totaljob: 0,
      // totalitemassigned: 0,
      // totalitemready: 0,
      oilproducts: {
        chartData: {
          //
          labels: ["Raw Oil", "Recon Oil"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: [
                "#3495C6",
                "#33BBB7",
                "#33A02C",
                "#C1C1C1",
                "#EBEBEB",
              ],
              borderWidth: 0,
              //
              data: [35, 10],
            },
          ],
        },
        loaded: false,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: "right",
            labels: {
              usePointStyle: true,
              pointStyle: {
                margin: "10px",
              },
              boxWidth: 10,
              fontColor: "white",
            },
          },
          elements: {
            center: {
              text: "",
              //   color: "#000000", // Default is #000000
              fontStyle: "Poppins", // Default is Arial
              sidePadding: 20, // Default is 20 (as a percentage)
              minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
              lineHeight: 30, // Default is 25 (in px), used for when text wraps
            },
          },
          responsive: true,
          cutoutPercentage: 80,
          tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
          },
          animation: {
            duration: 500,
            onProgress: function (chart) {
              if (chart.chart.config.options.elements.center) {
                // Get ctx from string
                var ctx = chart.chart.ctx;

                // Get options from the center object in options
                var centerConfig = chart.chart.config.options.elements.center;
                var fontStyle = centerConfig.fontStyle || "Poppins";
                var txt = centerConfig.text;
                var color = centerConfig.color || "#000000";
                var maxFontSize = centerConfig.maxFontSize || 75;
                var sidePadding = centerConfig.sidePadding || 20;
                var sidePaddingCalculated =
                  (sidePadding / 100) * (chart.innerRadius * 2);
                // Start with a base font of 30px
                ctx.font = "20px " + fontStyle;

                // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                var stringWidth = ctx.measureText(txt).width;
                var elementWidth =
                  chart.innerRadius * 2 - sidePaddingCalculated;

                // Find out how much the font can grow in width.
                var widthRatio = elementWidth / stringWidth;
                var newFontSize = Math.floor(30 * widthRatio);
                var elementHeight = chart.innerRadius * 2;

                // Pick a new font size so it will not be larger than the height of label.
                var fontSizeToUse = Math.min(
                  newFontSize,
                  elementHeight,
                  maxFontSize
                );
                var minFontSize = centerConfig.minFontSize;
                var lineHeight = centerConfig.lineHeight || 25;
                var wrapText = false;

                if (minFontSize === undefined) {
                  minFontSize = 20;
                }

                if (minFontSize && fontSizeToUse < minFontSize) {
                  fontSizeToUse = minFontSize;
                  wrapText = true;
                }

                // Set font settings to draw it correctly.
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                var centerX =
                  (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                  2;
                var centerY =
                  (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                  2;
                ctx.font = fontSizeToUse + "px " + fontStyle;
                ctx.fillStyle = color;

                //Draw text in center
                ctx.font = " 20px Poppins, sans-serif";
                ctx.fillStyle = "#000000";
                ctx.fillText("Oil", centerX, centerY - 10);
                ctx.fillText("Products", centerX, centerY + 15);
              }
            },
          },

          scales: {
            yAxes: [
              {
                display: 0,
                ticks: {
                  display: false,
                },
                gridLines: {
                  drawBorder: false,
                  zeroLineColor: "transparent",
                  color: "rgba(255,255,255,0.05)",
                },
              },
            ],

            xAxes: [
              {
                display: 0,
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(255,255,255,0.1)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      oilcollected: {
        chartData: {
          labels: [],
          datasets: [
            {
              yAxisID: "a",
              type: "line",
              label: "Sellable",
              fill: false,
              borderColor: "#32BA7C",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.5,
              pointBackgroundColor: "#32BA7C",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#32BA7C",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [5],
            },
            {
              yAxisID: "b",
              type: "line",
              label: "Non-sellable",
              fill: false,
              borderColor: "#358CCB",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#358CCB",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#358CCB",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [9],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptionsllll,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 1, 1],
      },
      salescollected: {
        chartData: {
          labels: [],
          datasets: [
            {
              yAxisID: "a",
              type: "line",
              label: "Sellable",
              fill: false,
              borderColor: "#32BA7C",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.5,
              pointBackgroundColor: "#32BA7C",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#32BA7C",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [5],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.blueChartOptionss,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 1, 1],
      },
      wastesdisposed: {
        chartData: {
          labels: [],
          datasets: [
            {
              yAxisID: "a",
              type: "line",
              label: "Sellable",
              fill: false,
              borderColor: "#32BA7C",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.5,
              pointBackgroundColor: "#32BA7C",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#32BA7C",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [5],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.blueChartOptionss,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 1, 1],
      },
      oil: [
        {
          title: "Raw Oil",
          color: "#3495C6",
        },
        {
          title: "Recon Oil",
          color: "#33BBB7",
        },
      ],
      top10sales: [
        { name: 'sw', total: 5 }
      ],
      top5wastes: [
        { name: 'sw', total: 5 }
      ],
      top5sellable: [
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
      ],
      top5nonsellable: [
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
        {
          name: "sw",
          total: 5,
        },
      ],
    };
  },
  methods: {
    getlandpiedata() {
      let start = moment(this.selects.date[0]).format("YYYY-MM-DD");
      let end = moment(this.selects.date[1]).format("YYYY-MM-DD");

      this.$http
        .get(
          ":10001/api/v1/overview/incoming/new?start_date=" +
          start +
          "&end_date=" +
          end +
          "&service_location=" +
          this.selects.port
        )
        .then((res) => {
          let response = res.message;
          console.log(response);

          this.total = {
            value: [],
            label: [],
            color: [],
          };
          this.completed = {
            value: [],
            label: [],
            color: [],
          };
          this.pending = {
            value: [],
            label: [],
            color: [],
          };
          this.overdue = {
            value: [],
            label: [],
            color: [],
          };

          this.total2 = {
            value: [],
            label: [],
            color: [],
          };
          this.completed2 = {
            value: [],
            label: [],
            color: [],
          };
          this.pending2 = {
            value: [],
            label: [],
            color: [],
          };
          this.overdue2 = {
            value: [],
            label: [],
            color: [],
          };


          if (response.land_generated_donut_chart.total.data != null) {
            this.total = {
              value: response.land_generated_donut_chart.total.data,
              label: response.land_generated_donut_chart.total.label,
              color: response.land_generated_donut_chart.total.color,
            };
          }

          if (response.land_generated_donut_chart.completed.data != null) {
            this.completed = {
              value: response.land_generated_donut_chart.completed.data,
              label: response.land_generated_donut_chart.completed.label,
              color: response.land_generated_donut_chart.completed.color,
            };
          }

          if (response.land_generated_donut_chart.pending.data != null) {
            this.pending = {
              value: response.land_generated_donut_chart.pending.data,
              label: response.land_generated_donut_chart.pending.label,
              color: response.land_generated_donut_chart.pending.color,
            };
          }
          if (response.land_generated_donut_chart.overdue.data != null) {
            this.overdue = {
              value: response.land_generated_donut_chart.overdue.data,
              label: response.land_generated_donut_chart.overdue.label,
              color: response.land_generated_donut_chart.overdue.color,
            };
          }

          this.assignedchart();


          // if (response.vessel_generated_donut_chart.total.data != null) {
          //   this.total2 = {
          //     value: response.vessel_generated_donut_chart.total.data,
          //     label: response.vessel_generated_donut_chart.total.label,
          //     color: response.vessel_generated_donut_chart.total.color,
          //   };
          // }

          if (response.vessel_generated_donut_chart.completed.data != null) {
            this.completed2 = {
              value: response.vessel_generated_donut_chart.completed.data,
              label: response.vessel_generated_donut_chart.completed.label,
              color: response.vessel_generated_donut_chart.completed.color,
            };
          }

          // if (response.vessel_generated_donut_chart.pending.data != null) {
          //   this.pending2 = {
          //     value: response.vessel_generated_donut_chart.pending.data,
          //     label: response.vessel_generated_donut_chart.pending.label,
          //     color: response.vessel_generated_donut_chart.pending.color,
          //   };
          // }
          // if (response.vessel_generated_donut_chart.overdue.data != null) {
          //   this.overdue2 = {
          //     value: response.vessel_generated_donut_chart.overdue.data,
          //     label: response.vessel_generated_donut_chart.overdue.label,
          //     color: response.vessel_generated_donut_chart.overdue.color,
          //   };
          // }

          this.assignedchart2();
        });
    },
    assignedchart() {
      this.landgenerated.loaded = false;
      console.log(this.total.label);
      console.log(this.total.value);
      console.log(this.total.color);
      console.log(this.landflag);
      if (this.landflag == "total") {
        this.landgenerated = {
          chartData: {
            labels: this.total.label,
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: this.total.color,
                borderWidth: 0,
                data: this.total.value,
              },
            ],
          },
          loaded: true,
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                pointStyle: {
                  margin: "10px",
                },
                boxWidth: 10,
                fontColor: "white",
              },
            },
            elements: {
              center: {
                text: "",
                //   color: "#000000", // Default is #000000
                fontStyle: "Poppins", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 30, // Default is 25 (in px), used for when text wraps
              },
            },
            responsive: true,
            cutoutPercentage: 80,
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            animation: {
              duration: 100,
              onComplete: function (chart) {
                if (chart.chart.config.options.elements.center) {
                  // Get ctx from string
                  var ctx = chart.chart.ctx;

                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  var centerX =
                    (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                    2;
                  var centerY =
                    (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                    2;

                  //Draw text in center
                  ctx.font = " 20px Poppins, sans-serif";
                  ctx.fillStyle = "#000000";
                  ctx.fillText("Job", centerX, centerY - 10);
                  ctx.fillText("Request", centerX, centerY + 15);
                }
              },
            },

            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false,
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: "transparent",
                    color: "rgba(255,255,255,0.05)",
                  },
                },
              ],

              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    display: false,
                  },
                },
              ],
            },
          },
        };
        this.land = [];
        for (var i = 0; i < this.total.label.length; i++) {
          let obj = {
            title: this.total.label[i],
            color: this.total.color[i],
          };
          this.land.push(obj);
        }
      }

      if (this.landflag == "completed") {
        this.landgenerated = {
          chartData: {
            labels: this.completed.label,
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: this.completed.color,
                borderWidth: 0,
                data: this.completed.value,
              },
            ],
          },
          loaded: true,
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                pointStyle: {
                  margin: "10px",
                },
                boxWidth: 10,
                fontColor: "white",
              },
            },
            elements: {
              center: {
                text: "",
                //   color: "#000000", // Default is #000000
                fontStyle: "Poppins", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 30, // Default is 25 (in px), used for when text wraps
              },
            },
            responsive: true,
            cutoutPercentage: 80,
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            animation: {
              duration: 500,
              onComplete: function (chart) {
                if (chart.chart.config.options.elements.center) {
                  // Get ctx from string
                  var ctx = chart.chart.ctx;

                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  var centerX =
                    (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                    2;
                  var centerY =
                    (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                    2;

                  //Draw text in center
                  ctx.font = " 20px Poppins, sans-serif";
                  ctx.fillStyle = "#000000";
                  ctx.fillText("Land", centerX, centerY - 10);
                  ctx.fillText("Generated", centerX, centerY + 15);
                }
              },
            },

            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false,
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: "transparent",
                    color: "rgba(255,255,255,0.05)",
                  },
                },
              ],

              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    display: false,
                  },
                },
              ],
            },
          },
        };  
        this.land = [];
        for (var i = 0; i < this.completed.label.length; i++) {
          let obj = {
            title: this.completed.label[i],
            color: this.completed.color[i],
          };
          this.land.push(obj);
        }
      }

      if (this.landflag == "pending") {
        this.landgenerated = {
          chartData: {
            labels: this.pending.label,
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: this.pending.color,
                borderWidth: 0,
                data: this.pending.value,
              },
            ],
          },
          loaded: true,
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                pointStyle: {
                  margin: "10px",
                },
                boxWidth: 10,
                fontColor: "white",
              },
            },
            elements: {
              center: {
                text: "",
                //   color: "#000000", // Default is #000000
                fontStyle: "Poppins", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 30, // Default is 25 (in px), used for when text wraps
              },
            },
            responsive: true,
            cutoutPercentage: 80,
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            animation: {
              duration: 500,
              onComplete: function (chart) {
                if (chart.chart.config.options.elements.center) {
                  // Get ctx from string
                  var ctx = chart.chart.ctx;

                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  var centerX =
                    (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                    2;
                  var centerY =
                    (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                    2;

                  //Draw text in center
                  ctx.font = " 20px Poppins, sans-serif";
                  ctx.fillStyle = "#000000";
                  ctx.fillText("Land", centerX, centerY - 10);
                  ctx.fillText("Generated", centerX, centerY + 15);
                }
              },
            },

            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false,
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: "transparent",
                    color: "rgba(255,255,255,0.05)",
                  },
                },
              ],

              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    display: false,
                  },
                },
              ],
            },
          },
        };

        this.land = [];
        for (var i = 0; i < this.pending.label.length; i++) {
          let obj = {
            title: this.pending.label[i],
            color: this.pending.color[i],
          };
          this.land.push(obj);
        }
      }

      if (this.landflag == "overdue") {
        this.landgenerated = {
          chartData: {
            labels: this.overdue.label,
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: this.overdue.color,
                borderWidth: 0,
                data: this.overdue.value,
              },
            ],
          },
          loaded: true,
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                pointStyle: {
                  margin: "10px",
                },
                boxWidth: 10,
                fontColor: "white",
              },
            },
            elements: {
              center: {
                text: "",
                //   color: "#000000", // Default is #000000
                fontStyle: "Poppins", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 30, // Default is 25 (in px), used for when text wraps
              },
            },
            responsive: true,
            cutoutPercentage: 80,
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            animation: {
              duration: 500,
              onComplete: function (chart) {
                if (chart.chart.config.options.elements.center) {
                  // Get ctx from string
                  var ctx = chart.chart.ctx;

                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  var centerX =
                    (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                    2;
                  var centerY =
                    (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                    2;

                  //Draw text in center
                  ctx.font = " 20px Poppins, sans-serif";
                  ctx.fillStyle = "#000000";
                  ctx.fillText("Land", centerX, centerY - 10);
                  ctx.fillText("Generated", centerX, centerY + 15);
                }
              },
            },

            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false,
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: "transparent",
                    color: "rgba(255,255,255,0.05)",
                  },
                },
              ],

              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    display: false,
                  },
                },
              ],
            },
          },
        };

        this.land = [];
        for (var i = 0; i < this.overdue.label.length; i++) {
          let obj = {
            title: this.overdue.label[i],
            color: this.overdue.color[i],
          };
          this.land.push(obj);
        }
      }
    },
    assignedchart2() {
      this.vesselgenerated.loaded = false;
      // console.log(this.total.label);
      // console.log(this.total.value);
      // console.log(this.total.color);
      // console.log(this.landflag);



      this.vesselgenerated = {
        chartData: {
          labels: this.completed2.label,
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: this.completed2.color,
              borderWidth: 0,
              data: this.completed2.value,
            },
          ],
        },
        loaded: true,
        extraOptions: {
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: "right",
            labels: {
              usePointStyle: true,
              pointStyle: {
                margin: "10px",
              },
              boxWidth: 10,
              fontColor: "white",
            },
          },
          elements: {
            center: {
              text: "",
              //   color: "#000000", // Default is #000000
              fontStyle: "Poppins", // Default is Arial
              sidePadding: 20, // Default is 20 (as a percentage)
              minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
              lineHeight: 30, // Default is 25 (in px), used for when text wraps
            },
          },
          responsive: true,
          cutoutPercentage: 80,
          tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
          },
          animation: {
            duration: 500,
            onComplete: function (chart) {
              if (chart.chart.config.options.elements.center) {
                // Get ctx from string
                var ctx = chart.chart.ctx;

                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                var centerX =
                  (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                  2;
                var centerY =
                  (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                  2;

                //Draw text in center
                ctx.font = " 20px Poppins, sans-serif";
                ctx.fillStyle = "#000000";
                ctx.fillText("Annex", centerX, centerY - 10);
                ctx.fillText("Collected", centerX, centerY + 15);
              }
            },
          },

          scales: {
            yAxes: [
              {
                display: 0,
                ticks: {
                  display: false,
                },
                gridLines: {
                  drawBorder: false,
                  zeroLineColor: "transparent",
                  color: "rgba(255,255,255,0.05)",
                },
              },
            ],

            xAxes: [
              {
                display: 0,
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(255,255,255,0.1)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  display: false,
                },
              },
            ],
          },
        },
      };
      this.vessel = [];
      for (var i = 0; i < this.completed2.label.length; i++) {
        let obj = {
          title: this.completed2.label[i],
          color: this.completed2.color[i],
        };
        this.vessel.push(obj);
      }




    },
    generateland(flag) {
      this.landflag = flag;
      if (flag == "total") {
        this.incominglandpie1 = "color: #358CCB !important;";
        this.incominglandpie2 = "color: #000000";
        this.incominglandpie3 = "color: #000000";
        this.incominglandpie4 = "color: #000000";
      }

      if (flag == "completed") {
        this.incominglandpie1 = "color: #000000  ";
        this.incominglandpie2 = "color: #358CCB !important;";
        this.incominglandpie3 = "color: #000000";
        this.incominglandpie4 = "color: #000000";
      }

      if (flag == "pending") {
        this.incominglandpie1 = "color: #000000  ";
        this.incominglandpie2 = "color: #000000";
        this.incominglandpie3 = "color: #358CCB !important;";
        this.incominglandpie4 = "color: #000000";
      }

      if (flag == "overdue") {
        this.incominglandpie1 = "color: #000000  ";
        this.incominglandpie2 = "color: #000000";
        this.incominglandpie3 = "color: #000000";
        this.incominglandpie4 = "color: #358CCB !important;";
      }

      this.assignedchart();
    },
    generatevessel(flag) {
      this.vesselflag = flag;
      if (flag == "total") {
        this.incomingvesselpie1 = "color: #358CCB !important;";
        this.incomingvesselpie2 = "color: #000000";
        this.incomingvesselpie3 = "color: #000000";
        this.incomingvesselpie4 = "color: #000000";
      }

      if (flag == "completed") {
        this.incomingvesselpie1 = "color: #000000  ";
        this.incomingvesselpie2 = "color: #358CCB !important;";
        this.incomingvesselpie3 = "color: #000000";
        this.incomingvesselpie4 = "color: #000000";
      }

      if (flag == "pending") {
        this.incomingvesselpie1 = "color: #000000  ";
        this.incomingvesselpie2 = "color: #000000";
        this.incomingvesselpie3 = "color: #358CCB !important;";
        this.incomingvesselpie4 = "color: #000000";
      }

      if (flag == "overdue") {
        this.incomingvesselpie1 = "color: #000000  ";
        this.incomingvesselpie2 = "color: #000000";
        this.incomingvesselpie3 = "color: #000000";
        this.incomingvesselpie4 = "color: #358CCB !important;";
      }

      this.assignedchart2();
    },
    tabActive(flag) {
      this.flag = flag;
      if (flag == "incoming") {
        this.selects.date = [moment().startOf("y"), moment().endOf("y")];
        this.incoming = "color: #358CCB !important;";
        this.preprocessing = "color: #000000";
        this.outgoing = "color: #000000";
        this.sales = "color: #000000";
      }

      if (flag == "preprocessing") {
        this.selects.date = [moment().startOf("y"), moment().endOf("y")];

        this.incoming = "color: #000000  ";
        this.preprocessing = "color: #358CCB !important;";
        this.outgoing = "color: #000000";
        this.sales = "color: #000000";
      }

      if (flag == "outgoing") {
        this.selects.date = [moment().startOf("y"), moment().endOf("y")];

        this.incoming = "color: #000000  ";
        this.preprocessing = "color: #000000";
        this.outgoing = "color: #358CCB !important;";
        this.sales = "color: #000000";
      }

      if (flag == "sales") {
        this.selects.date = moment().startOf("y");

        this.daterange = moment().format("YYYY");

        this.incoming = "color: #000000  ";
        this.preprocessing = "color: #000000";
        this.outgoing = "color: #000000";
        this.sales = "color: #358CCB !important;";
      }

      this.getData();
    },
    getPort() {
      this.selects.ports = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;

          this.selects.ports.push({ label: "All", value: "" });
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };
            this.selects.ports.push(obj);
          }
          this.selects.port = this.selects.ports[0].value;
        }
      });
    },
    getData() {
      this.wastecollected.loaded = false;
      this.oilcollected.loaded = false;



      this.oil = [];

      let start = moment(this.selects.date[0]).format("YYYY-MM-DD");
      let end = moment(this.selects.date[1]).format("YYYY-MM-DD");
      if (this.flag == "incoming") {
        this.$http
          .get(
            ":10001/api/v1/overview/incoming/new?start_date=" +
            start +
            "&end_date=" +
            end +
            "&service_location=" +
            this.selects.port
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);

              console.log("INCOMING");
              this.totaljobrequest = response.job_request.total_job_request;
              this.completedjobrequest =
                response.job_request.completed_job_request;
              this.pendingjobrequest = response.job_request.pending_job_request;
              this.overduejobrequest = response.job_request.overdue;

              // line chart
              let timestamp = [];
              let land = [];
              let vessel = [];
              for (var i = 0; i < response.graph.month.length; i++) {
                timestamp.push(util.capitalizeFirstLetter(response.graph.month[i].month_name));
                land.push(response.graph.month[i].data.land);
                vessel.push(response.graph.month[i].data.vessel);
              }

              this.wastecollected = {
                chartData: {
                  labels: timestamp,
                  datasets: [
                    {
                      yAxisID: "y-axis-1",
                      type: "line",
                      label: "Vessel Generated",
                      fill: false,
                      borderColor: "#32BA7C",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      pointBackgroundColor: "#32BA7C",
                      pointBorderColor: "rgba(255,255,255,0)",
                      pointHoverBackgroundColor: "#32BA7C",
                      pointBorderWidth: 20,
                      pointHoverRadius: 4,
                      pointHoverBorderWidth: 15,
                      pointRadius: 4,
                      data: vessel,
                    },
                    {
                      yAxisID: "y-axis-2",
                      type: "line",
                      label: "Land Generated",
                      fill: false,
                      borderColor: "#358CCB",
                      borderWidth: 2,
                      borderDash: [],
                      borderDashOffset: 0.0,
                      pointBackgroundColor: "#358CCB",
                      pointBorderColor: "rgba(255,255,255,0)",
                      pointHoverBackgroundColor: "#358CCB",
                      pointBorderWidth: 20,
                      pointHoverRadius: 4,
                      pointHoverBorderWidth: 15,
                      pointRadius: 4,
                      data: land,
                    },
                  ],
                },
                loaded: true,

                extraOptions: chartConfigs.purpleChartOptionslll,
                gradientColors: config.colors.primaryGradient,
                gradientStops: [1, 1, 1],
              };

              this.totalcollection = response.job_request.total_job_request;

              this.total5swcollected = [];
              if (response.top_sw != null) {
                for (var i = 0; i < response.top_sw.length; i++) {
                  let obj = {
                    name: response.top_sw[i].Name,
                    total: response.top_sw[i].Count,
                  };
                  this.total5swcollected.push(obj);
                }
              }

              this.total5annexcollected = [];
              if (response.annex_weight != null) {
                for (var i = 0; i < response.annex_weight.length; i++) {
                  let obj = {
                    name: response.annex_weight[i].Name,
                    total: response.annex_weight[i].Count,
                  };

                  this.total5annexcollected.push(obj);
                }
              }

              //   land generated pie chart

              let vessellabel = [];
              let vesseldata = [];

              if (response.vessel_generated != null) {
                for (var i = 0; i < response.vessel_generated.length; i++) {
                  for (var j = 0; j < this.vessel.length; j++) {
                    if (
                      response.vessel_generated[i].name
                        .split("-")[0]
                        .trim()
                        .toUpperCase() == this.vessel[j].title.toUpperCase()
                    ) {
                      vessellabel[j] = this.vessel[j].title;
                      vesseldata[j] = response.vessel_generated[i].amount;
                    }
                  }
                }
              }

              this.vesselgenerated = {
                chartData: {
                  labels: vessellabel,
                  datasets: [
                    {
                      pointRadius: 0,
                      pointHoverRadius: 0,
                      backgroundColor: [
                        "#3495C6",
                        "#33BBB7",
                        "#33A02C",
                        "#C1C1C1",
                        "#EBEBEB",
                      ],
                      borderWidth: 0,
                      data: vesseldata,
                    },
                  ],
                },
                loaded: true,
                extraOptions: {
                  maintainAspectRatio: false,
                  legend: {
                    display: false,
                    position: "right",
                    labels: {
                      usePointStyle: true,
                      pointStyle: {
                        margin: "10px",
                      },
                      boxWidth: 10,
                      fontColor: "white",
                    },
                  },
                  elements: {
                    center: {
                      text: "",
                      //   color: "#000000", // Default is #000000
                      fontStyle: "Poppins", // Default is Arial
                      sidePadding: 20, // Default is 20 (as a percentage)
                      minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                      lineHeight: 30, // Default is 25 (in px), used for when text wraps
                    },
                  },
                  responsive: true,
                  cutoutPercentage: 80,
                  tooltips: {
                    backgroundColor: "#f5f5f5",
                    titleFontColor: "#333",
                    bodyFontColor: "#666",
                    bodySpacing: 4,
                    xPadding: 12,
                    mode: "nearest",
                    intersect: 0,
                    position: "nearest",
                  },
                  animation: {
                    duration: 500,
                    onComplete: function (chart) {
                      if (chart.chart.config.options.elements.center) {
                        // Get ctx from string
                        var ctx = chart.chart.ctx;

                        ctx.textAlign = "center";
                        ctx.textBaseline = "middle";
                        var centerX =
                          (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                          2;
                        var centerY =
                          (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                          2;

                        //Draw text in center
                        ctx.font = " 20px Poppins, sans-serif";
                        ctx.fillStyle = "#000000";
                        ctx.fillText("Annex", centerX, centerY - 10);
                        ctx.fillText("Collected", centerX, centerY + 15);
                      }
                    },
                  },

                  scales: {
                    yAxes: [
                      {
                        display: 0,
                        ticks: {
                          display: false,
                        },
                        gridLines: {
                          drawBorder: false,
                          zeroLineColor: "transparent",
                          color: "rgba(255,255,255,0.05)",
                        },
                      },
                    ],

                    xAxes: [
                      {
                        display: 0,
                        barPercentage: 1.6,
                        gridLines: {
                          drawBorder: false,
                          color: "rgba(255,255,255,0.1)",
                          zeroLineColor: "transparent",
                        },
                        ticks: {
                          display: false,
                        },
                      },
                    ],
                  },
                },
              };
            }
          });
      }

      if (this.flag == "preprocessing") {
        this.$http
          .get(
            ":10001/api/v1/overview/" +
            this.flag +
            "?start_date=" +
            start +
            "&end_date=" +
            end +
            "&service_location=" +
            this.selects.port
          )
          .then((res) => {
            let response = res.message;
            this.oilcollected.loaded = false;

            // card data
            this.totaljobinprogress =
              response.aggregated_overview_status.pending;
            this.totaljobcompleted =
              response.aggregated_overview_status.completed;
            this.totaljob = response.aggregated_overview_status.total;

            // line chart data
            let timestamp = [];
            let data1 = [];
            let data2 = [];
            for (var i = 0; i < response.graph.month.length; i++) {
              timestamp.push(
                this.camelCase(response.graph.month[i].month_name)
              );
              data1.push(response.graph.month[i].data.sellable);
              data2.push(response.graph.month[i].data.non_sellable);
            }

            this.oilcollected = {
              chartData: {
                // labels: ["jojo"],
                labels: timestamp,
                datasets: [
                  {
                    yAxisID: "y-axis-1",
                    type: "line",
                    label: "Sellable",
                    fill: false,
                    borderColor: "#32BA7C",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.5,
                    pointBackgroundColor: "#32BA7C",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#32BA7C",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: data1,
                    // data: [5],
                  },
                  {
                    yAxisID: "y-axis-2",
                    type: "line",
                    label: "Non-sellable",
                    fill: false,
                    borderColor: "#358CCB",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "#358CCB",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#358CCB",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: data2,
                    // data: [9],
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.purpleChartOptionslll,
              gradientColors: config.colors.primaryGradient,
              gradientStops: [1, 1, 1],
            };

            // calculate total collection
            let sum1 = 0;
            for (let i = 0; i < data1.length; i++) {
              sum1 += data1[i];
            }

            let sum2 = 0;
            for (let i = 0; i < data2.length; i++) {
              sum2 += data2[i];
            }
            this.totalcollection = sum1 + sum2 + " MT";

            // marshalling pie chart
            let label = [];
            let data = [];
            let colors = [];
            for (
              var i = 0;
              i <
              response.aggregated_preprocessing_produce.sellable_vs_non_sellable
                .length;
              i++
            ) {
              label.push(
                response.aggregated_preprocessing_produce
                  .sellable_vs_non_sellable[i].name
              );
              data.push(
                response.aggregated_preprocessing_produce
                  .sellable_vs_non_sellable[i].quantity
              );
              colors.push(
                response.aggregated_preprocessing_produce
                  .sellable_vs_non_sellable[i].background
              );

              // marshalling legend
              let oo = {
                title:
                  response.aggregated_preprocessing_produce
                    .sellable_vs_non_sellable[i].name,
                color:
                  response.aggregated_preprocessing_produce
                    .sellable_vs_non_sellable[i].background,
              };

              this.oil.push(oo);
            }

            this.oilproducts = {
              chartData: {
                //
                labels: label,
                datasets: [
                  {
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    backgroundColor: colors,
                    borderWidth: 0,
                    //
                    data: data,
                  },
                ],
              },
              loaded: true,
              extraOptions: {
                maintainAspectRatio: false,
                legend: {
                  display: false,
                  position: "right",
                  labels: {
                    usePointStyle: true,
                    pointStyle: {
                      margin: "10px",
                    },
                    boxWidth: 10,
                    fontColor: "white",
                  },
                },
                elements: {
                  center: {
                    text: "",
                    //   color: "#000000", // Default is #000000
                    fontStyle: "Poppins", // Default is Arial
                    sidePadding: 20, // Default is 20 (as a percentage)
                    minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                    lineHeight: 30, // Default is 25 (in px), used for when text wraps
                  },
                },
                responsive: true,
                cutoutPercentage: 80,
                tooltips: {
                  backgroundColor: "#f5f5f5",
                  titleFontColor: "#333",
                  bodyFontColor: "#666",
                  bodySpacing: 4,
                  xPadding: 12,
                  mode: "nearest",
                  intersect: 0,
                  position: "nearest",
                },
                animation: {
                  duration: 500,
                  onProgress: function (chart) {
                    if (chart.chart.config.options.elements.center) {
                      // Get ctx from string
                      var ctx = chart.chart.ctx;

                      // Get options from the center object in options
                      var centerConfig =
                        chart.chart.config.options.elements.center;
                      var fontStyle = centerConfig.fontStyle || "Poppins";
                      var txt = centerConfig.text;
                      var color = centerConfig.color || "#000000";
                      var maxFontSize = centerConfig.maxFontSize || 75;
                      var sidePadding = centerConfig.sidePadding || 20;
                      var sidePaddingCalculated =
                        (sidePadding / 100) * (chart.innerRadius * 2);
                      // Start with a base font of 30px
                      ctx.font = "20px " + fontStyle;

                      // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                      var stringWidth = ctx.measureText(txt).width;
                      var elementWidth =
                        chart.innerRadius * 2 - sidePaddingCalculated;

                      // Find out how much the font can grow in width.
                      var widthRatio = elementWidth / stringWidth;
                      var newFontSize = Math.floor(30 * widthRatio);
                      var elementHeight = chart.innerRadius * 2;

                      // Pick a new font size so it will not be larger than the height of label.
                      var fontSizeToUse = Math.min(
                        newFontSize,
                        elementHeight,
                        maxFontSize
                      );
                      var minFontSize = centerConfig.minFontSize;
                      var lineHeight = centerConfig.lineHeight || 25;
                      var wrapText = false;

                      if (minFontSize === undefined) {
                        minFontSize = 20;
                      }

                      if (minFontSize && fontSizeToUse < minFontSize) {
                        fontSizeToUse = minFontSize;
                        wrapText = true;
                      }

                      // Set font settings to draw it correctly.
                      ctx.textAlign = "center";
                      ctx.textBaseline = "middle";

                      var centerX =
                        (chart.chart.chartArea.left +
                          chart.chart.chartArea.right) /
                        2;
                      var centerY =
                        (chart.chart.chartArea.top +
                          chart.chart.chartArea.bottom) /
                        2;
                      ctx.font = fontSizeToUse + "px " + fontStyle;
                      ctx.fillStyle = color;

                      //Draw text in center
                      ctx.font = " 20px Poppins, sans-serif";
                      ctx.fillStyle = "#000000";
                      ctx.fillText("Oil", centerX, centerY - 10);
                      ctx.fillText("Products", centerX, centerY + 15);
                    }
                  },
                },

                scales: {
                  yAxes: [
                    {
                      display: 0,
                      ticks: {
                        display: false,
                      },
                      gridLines: {
                        drawBorder: false,
                        zeroLineColor: "transparent",
                        color: "rgba(255,255,255,0.05)",
                      },
                    },
                  ],

                  xAxes: [
                    {
                      display: 0,
                      barPercentage: 1.6,
                      gridLines: {
                        drawBorder: false,
                        color: "rgba(255,255,255,0.1)",
                        zeroLineColor: "transparent",
                      },
                      ticks: {
                        display: false,
                      },
                    },
                  ],
                },
              },
            };

            // top 5 sellable
            this.top5sellable = [];
            for (
              var i = 0;
              i < response.aggregated_preprocessing_produce.sellable.length;
              i++
            ) {
              let obj = {
                name: response.aggregated_preprocessing_produce.sellable[i]
                  .name,
                total:
                  response.aggregated_preprocessing_produce.sellable[i]
                    .quantity,
              };
              this.top5sellable.push(obj);
            }

            // top 5 non-sellable
            this.top5nonsellable = [];
            for (
              var i = 0;
              i < response.aggregated_preprocessing_produce.non_sellable.length;
              i++
            ) {
              let obj = {
                name: response.aggregated_preprocessing_produce.non_sellable[i]
                  .name,
                total:
                  response.aggregated_preprocessing_produce.non_sellable[i]
                    .quantity,
              };
              this.top5nonsellable.push(obj);
            }
          });
      }

      if (this.flag == "outgoing") {
        //at the end adjust based on selected date range
        this.$http
          .get(
            ":10001/api/v1/overview/outgoing?start_date=" +
            start +
            "&end_date=" +
            end
            +
            "&service_location"
            //  +
            // this.selects.port
          )
          .then((res) => {
            let response = res.message;
            this.wastesdisposed.loaded = false;

            this.totaljobcreated = response.job_status.created;
            this.totaljobaccepted = response.job_status.accepted;
            this.totaljobcomplete = response.job_status.completed;
            this.overduejob = response.job_status.pending;


            let timestamp = [];
            let data1 = [];
            let data2 = [];
            for (var i = 0; i < response.graph.label_month.length; i++) {
              timestamp.push(
                response.graph.label_month[i]
              );
              data1.push(response.graph.quantity[i]);
            }
            this.totaldisposal = 0;

            for (var i = 0; i < response.graph.quantity.length; i++) {
              this.totaldisposal += response.graph.quantity[i];
            }

            this.wastesdisposed = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    yAxisID: "y-axis-1",
                    type: "line",
                    label: "Waste",
                    fill: false,
                    borderColor: "#358CCB",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.5,
                    pointBackgroundColor: "#358CCB",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#358CCB",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: data1,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.blueChartOptionss,
              gradientColors: config.colors.primaryGradient,
              gradientStops: [1, 1, 1],
            };

            this.top5wastes = [];
            for (
              var i = 0;
              i < response.top_outgoing.length;
              i++
            ) {
              let obj = {
                name: response.top_outgoing[i]
                  .name,
                total:
                  response.top_outgoing[i]
                    .quantity,
              };
              this.top5wastes.push(obj);
            }

          });
      }

      if (this.flag == "sales") {
        console.log(this.selects.date)
        //at the end adjust based on selected date range
        this.$http
          .get(
            ":10001/api/v1/overview/sale?year=" +
            moment(this.selects.date).format("YYYY")
          )
          .then((res) => {
            let response = res.message;

            console.log(response);

            this.salescollected.loaded = false;

            let formatter = new Intl.NumberFormat("en-US");
            var totals = 0;
            for (var i = 0; i < response.sale.length; i++) {
              var total = response.sale[i].earning;

              totals += total;
            }

            this.totalsales = 0;

            for (var i = 0; i < response.graph.data.length; i++) {
              this.totalsales += response.graph.data[i];
            }

            this.totalsales = formatter.format(this.totalsales);


            const today = new Date();
            this.formattedDate = today.toDateString();
            this.month = today.getMonth();
            this.quarter = Math.ceil((today.getMonth() + 1) / 3);

            var startmonth = 0;

            console.log(this.month)
            console.log('quater', this.quarter)
            console.log(response.sale)

            if (this.quarter == 1) {
              startmonth = 0;
            } else if (this.quarter == 2) {
              startmonth = 3;
            } else if (this.quarter == 3) {
              startmonth = 6;
            } else if (this.quarter == 4) {
              startmonth = 9;
            }

            var qua = 0;
            if (response.sale.length !== 0)
            for (let i = startmonth; i < startmonth + 3; i++) {
              let total = response.sale[i].earning;

              qua += total;
            }

            this.monthlysalestarget = formatter.format(response.sale[this.month].earning); //currentmonth
            this.quarterlysalestarget = formatter.format(qua); //currentquarter

            this.totalmonthlysalestarget = formatter.format(10000);
            this.totalquarterlysalestarget = formatter.format(100000);

            let timestamp = [];
            let data1 = [];
            let data2 = [];
            for (var i = 0; i < response.graph.label_month.length; i++) {
              timestamp.push(
                response.graph.label_month[i]
              );
              data1.push(response.graph.data[i]);
            }

            console.log(timestamp)
            console.log(data1)


            this.salescollected = {
              chartData: {
                labels: timestamp,
                datasets: [
                  {
                    yAxisID: "y-axis-1",
                    type: "line",
                    label: "Sales",
                    fill: false,
                    borderColor: "#358CCB",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.5,
                    pointBackgroundColor: "#358CCB",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#358CCB",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: data1,
                  },
                ],
              },
              loaded: true,
              extraOptions: chartConfigs.blueChartOptionss,
              gradientColors: config.colors.primaryGradient,
              gradientStops: [1, 1, 1],
            };

            this.top10sales = [];
            for (
              var i = 0;
              i < response.top_sale.length;
              i++
            ) {
              let obj = {
                name: response.top_sale[i]
                  .name,
                total:
                  formatter.format(response.top_sale[i]
                    .earning),
              };
              this.top10sales.push(obj);
            }

          });
      }

    },
    camelCase(str) {
      if (str != "") {
        var splitStr = str.toLowerCase().split(" ");
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(" ");
      }
    },
    // getDataById() {
    //   this.wastecollected.loaded = false;
    //   this.$http
    //     .get(
    //       ":10001/api/v1/overview/incoming/service_location=" +
    //         this.selects.port
    //     )
    //     .then((res) => {
    //       if (!res.error) {
    //         let response = res.message;

    //         this.totaljobrequest = response.job_request.total_job_request;
    //         this.completedjobrequest =
    //           response.job_request.completed_job_request;
    //         this.pendingjobrequest = response.job_request.pending_job_request;
    //         this.overduejobrequest = response.job_request.overdue;

    //         // line chart
    //         let timestamp = [];
    //         let land = [];
    //         let vessel = [];
    //         for (
    //           var i = 0;
    //           i < response.current_year_waste_collected[0].land.length;
    //           i++
    //         ) {
    //           timestamp.push(
    //             response.current_year_waste_collected[0].land[i].month_name
    //           );
    //           land.push(
    //             response.current_year_waste_collected[0].land[i].amount
    //           );
    //         }

    //         for (
    //           var i = 0;
    //           i < response.current_year_waste_collected[0].vessel.length;
    //           i++
    //         ) {
    //           vessel.push(
    //             response.current_year_waste_collected[0].vessel[i].amount
    //           );
    //         }

    //         this.wastecollected = {
    //           chartData: {
    //             labels: timestamp,
    //             datasets: [
    //               {
    //                 yAxisID: "y-axis-1",
    //                 type: "line",
    //                 label: "Vessel Generated",
    //                 fill: false,
    //                 borderColor: "#32BA7C",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "#32BA7C",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#32BA7C",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: vessel,
    //               },
    //               {
    //                 yAxisID: "y-axis-2",
    //                 type: "line",
    //                 label: "Land Generated",
    //                 fill: false,
    //                 borderColor: "#358CCB",
    //                 borderWidth: 2,
    //                 borderDash: [],
    //                 borderDashOffset: 0.0,
    //                 pointBackgroundColor: "#358CCB",
    //                 pointBorderColor: "rgba(255,255,255,0)",
    //                 pointHoverBackgroundColor: "#358CCB",
    //                 pointBorderWidth: 20,
    //                 pointHoverRadius: 4,
    //                 pointHoverBorderWidth: 15,
    //                 pointRadius: 4,
    //                 data: land,
    //               },
    //             ],
    //           },
    //           loaded: true,

    //           extraOptions: chartConfigs.purpleChartOptionslll,
    //           gradientColors: config.colors.primaryGradient,
    //           gradientStops: [1, 1, 1],
    //         };

    //         this.totalcollection =
    //           response.current_year_waste_collected[0].total_collection + " MT";

    //         this.total5swcollected = [];
    //         if (response.top_sw_collected != null) {
    //           for (var i = 0; i < response.top_sw_collected.length; i++) {
    //             let obj = {
    //               name: response.top_sw_collected[i].name,
    //               total: response.top_sw_collected[i].amount,
    //             };
    //             this.total5swcollected.push(obj);
    //           }
    //         }

    //         this.total5annexcollected = [];
    //         if (response.top_annex_collected != null) {
    //           for (var i = 0; i < response.top_annex_collected.length; i++) {
    //             let obj = {
    //               name: response.top_annex_collected[i].name,
    //               total: response.top_annex_collected[i].amount,
    //             };

    //             this.total5annexcollected.push(obj);
    //           }
    //         }

    //         //   land generated pie chart
    //         let landlabel = [];
    //         let landdata = [];
    //         for (var i = 0; i < response.land_generated.length; i++) {
    //           this.land[i].title = response.land_generated[i].name;
    //           landlabel.push(response.land_generated[i].name);
    //           landdata.push(response.land_generated[i].amount);
    //         }
    //         this.landgenerated = {
    //           chartData: {
    //             labels: landlabel,
    //             datasets: [
    //               {
    //                 pointRadius: 0,
    //                 pointHoverRadius: 0,
    //                 backgroundColor: [
    //                   "#3495C6",
    //                   "#33BBB7",
    //                   "#33A02C",
    //                   "#C1C1C1",
    //                   "#EBEBEB",
    //                 ],
    //                 borderWidth: 0,
    //                 data: landdata,
    //               },
    //             ],
    //           },
    //           loaded: true,
    //           extraOptions: {
    //             maintainAspectRatio: false,
    //             legend: {
    //               display: false,
    //               position: "right",
    //               labels: {
    //                 usePointStyle: true,
    //                 pointStyle: {
    //                   margin: "10px",
    //                 },
    //                 boxWidth: 10,
    //                 fontColor: "white",
    //               },
    //             },
    //             elements: {
    //               center: {
    //                 text: "",
    //                 //   color: "#000000", // Default is #000000
    //                 fontStyle: "Poppins", // Default is Arial
    //                 sidePadding: 20, // Default is 20 (as a percentage)
    //                 minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
    //                 lineHeight: 30, // Default is 25 (in px), used for when text wraps
    //               },
    //             },
    //             responsive: true,
    //             cutoutPercentage: 80,
    //             tooltips: {
    //               backgroundColor: "#f5f5f5",
    //               titleFontColor: "#333",
    //               bodyFontColor: "#666",
    //               bodySpacing: 4,
    //               xPadding: 12,
    //               mode: "nearest",
    //               intersect: 0,
    //               position: "nearest",
    //             },
    //             animation: {
    //               duration: 500,
    //               onProgress: function (chart) {
    //                 if (chart.chart.config.options.elements.center) {
    //                   // Get ctx from string
    //                   var ctx = chart.chart.ctx;

    //                   // Get options from the center object in options
    //                   var centerConfig =
    //                     chart.chart.config.options.elements.center;
    //                   var fontStyle = centerConfig.fontStyle || "Poppins";
    //                   var txt = centerConfig.text;
    //                   var color = centerConfig.color || "#000000";
    //                   var maxFontSize = centerConfig.maxFontSize || 75;
    //                   var sidePadding = centerConfig.sidePadding || 20;
    //                   var sidePaddingCalculated =
    //                     (sidePadding / 100) * (chart.innerRadius * 2);
    //                   // Start with a base font of 30px
    //                   ctx.font = "20px " + fontStyle;

    //                   // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
    //                   var stringWidth = ctx.measureText(txt).width;
    //                   var elementWidth =
    //                     chart.innerRadius * 2 - sidePaddingCalculated;

    //                   // Find out how much the font can grow in width.
    //                   var widthRatio = elementWidth / stringWidth;
    //                   var newFontSize = Math.floor(30 * widthRatio);
    //                   var elementHeight = chart.innerRadius * 2;

    //                   // Pick a new font size so it will not be larger than the height of label.
    //                   var fontSizeToUse = Math.min(
    //                     newFontSize,
    //                     elementHeight,
    //                     maxFontSize
    //                   );
    //                   var minFontSize = centerConfig.minFontSize;
    //                   var lineHeight = centerConfig.lineHeight || 25;
    //                   var wrapText = false;

    //                   if (minFontSize === undefined) {
    //                     minFontSize = 20;
    //                   }

    //                   if (minFontSize && fontSizeToUse < minFontSize) {
    //                     fontSizeToUse = minFontSize;
    //                     wrapText = true;
    //                   }

    //                   // Set font settings to draw it correctly.
    //                   ctx.textAlign = "center";
    //                   ctx.textBaseline = "middle";

    //                   var centerX =
    //                     (chart.chart.chartArea.left +
    //                       chart.chart.chartArea.right) /
    //                     2;
    //                   var centerY =
    //                     (chart.chart.chartArea.top +
    //                       chart.chart.chartArea.bottom) /
    //                     2;
    //                   ctx.font = fontSizeToUse + "px " + fontStyle;
    //                   ctx.fillStyle = color;

    //                   //Draw text in center
    //                   ctx.font = " 20px Poppins, sans-serif";
    //                   ctx.fillStyle = "#000000";
    //                   ctx.fillText("Land", centerX, centerY - 10);
    //                   ctx.fillText("Generated", centerX, centerY + 15);
    //                 }
    //               },
    //             },

    //             scales: {
    //               yAxes: [
    //                 {
    //                   display: 0,
    //                   ticks: {
    //                     display: false,
    //                   },
    //                   gridLines: {
    //                     drawBorder: false,
    //                     zeroLineColor: "transparent",
    //                     color: "rgba(255,255,255,0.05)",
    //                   },
    //                 },
    //               ],

    //               xAxes: [
    //                 {
    //                   display: 0,
    //                   barPercentage: 1.6,
    //                   gridLines: {
    //                     drawBorder: false,
    //                     color: "rgba(255,255,255,0.1)",
    //                     zeroLineColor: "transparent",
    //                   },
    //                   ticks: {
    //                     display: false,
    //                   },
    //                 },
    //               ],
    //             },
    //           },
    //         };

    //         let vessellabel = [];
    //         let vesseldata = [];
    //         for (var i = 0; i < response.vessel_generated.length; i++) {
    //           // this.vessel[i].title = response.vessel_generated[i].name;
    //           vessellabel.push(response.vessel_generated[i].name);
    //           vesseldata.push(response.vessel_generated[i].amount);
    //         }
    //         this.vesselgenerated = {
    //           chartData: {
    //             labels: vessellabel,
    //             datasets: [
    //               {
    //                 pointRadius: 0,
    //                 pointHoverRadius: 0,
    //                 backgroundColor: [
    //                   "#3495C6",
    //                   "#33BBB7",
    //                   "#33A02C",
    //                   "#C1C1C1",
    //                   "#EBEBEB",
    //                 ],
    //                 borderWidth: 0,
    //                 data: vesseldata,
    //               },
    //             ],
    //           },
    //           loaded: true,
    //           extraOptions: {
    //             maintainAspectRatio: false,
    //             legend: {
    //               display: false,
    //               position: "right",
    //               labels: {
    //                 usePointStyle: true,
    //                 pointStyle: {
    //                   margin: "10px",
    //                 },
    //                 boxWidth: 10,
    //                 fontColor: "white",
    //               },
    //             },
    //             elements: {
    //               center: {
    //                 text: "",
    //                 //   color: "#000000", // Default is #000000
    //                 fontStyle: "Poppins", // Default is Arial
    //                 sidePadding: 20, // Default is 20 (as a percentage)
    //                 minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
    //                 lineHeight: 30, // Default is 25 (in px), used for when text wraps
    //               },
    //             },
    //             responsive: true,
    //             cutoutPercentage: 80,
    //             tooltips: {
    //               backgroundColor: "#f5f5f5",
    //               titleFontColor: "#333",
    //               bodyFontColor: "#666",
    //               bodySpacing: 4,
    //               xPadding: 12,
    //               mode: "nearest",
    //               intersect: 0,
    //               position: "nearest",
    //             },
    //             animation: {
    //               duration: 500,
    //               onProgress: function (chart) {
    //                 if (chart.chart.config.options.elements.center) {
    //                   // Get ctx from string
    //                   var ctx = chart.chart.ctx;

    //                   // Get options from the center object in options
    //                   var centerConfig =
    //                     chart.chart.config.options.elements.center;
    //                   var fontStyle = centerConfig.fontStyle || "Poppins";
    //                   var txt = centerConfig.text;
    //                   var color = centerConfig.color || "#000000";
    //                   var maxFontSize = centerConfig.maxFontSize || 75;
    //                   var sidePadding = centerConfig.sidePadding || 20;
    //                   var sidePaddingCalculated =
    //                     (sidePadding / 100) * (chart.innerRadius * 2);
    //                   // Start with a base font of 30px
    //                   ctx.font = "20px " + fontStyle;

    //                   // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
    //                   var stringWidth = ctx.measureText(txt).width;
    //                   var elementWidth =
    //                     chart.innerRadius * 2 - sidePaddingCalculated;

    //                   // Find out how much the font can grow in width.
    //                   var widthRatio = elementWidth / stringWidth;
    //                   var newFontSize = Math.floor(30 * widthRatio);
    //                   var elementHeight = chart.innerRadius * 2;

    //                   // Pick a new font size so it will not be larger than the height of label.
    //                   var fontSizeToUse = Math.min(
    //                     newFontSize,
    //                     elementHeight,
    //                     maxFontSize
    //                   );
    //                   var minFontSize = centerConfig.minFontSize;
    //                   var lineHeight = centerConfig.lineHeight || 25;
    //                   var wrapText = false;

    //                   if (minFontSize === undefined) {
    //                     minFontSize = 20;
    //                   }

    //                   if (minFontSize && fontSizeToUse < minFontSize) {
    //                     fontSizeToUse = minFontSize;
    //                     wrapText = true;
    //                   }

    //                   // Set font settings to draw it correctly.
    //                   ctx.textAlign = "center";
    //                   ctx.textBaseline = "middle";

    //                   var centerX =
    //                     (chart.chart.chartArea.left +
    //                       chart.chart.chartArea.right) /
    //                     2;
    //                   var centerY =
    //                     (chart.chart.chartArea.top +
    //                       chart.chart.chartArea.bottom) /
    //                     2;
    //                   ctx.font = fontSizeToUse + "px " + fontStyle;
    //                   ctx.fillStyle = color;

    //                   //Draw text in center
    //                   ctx.font = " 20px Poppins, sans-serif";
    //                   ctx.fillStyle = "#000000";
    //                   ctx.fillText("Land", centerX, centerY - 10);
    //                   ctx.fillText("Generated", centerX, centerY + 15);
    //                 }
    //               },
    //             },

    //             scales: {
    //               yAxes: [
    //                 {
    //                   display: 0,
    //                   ticks: {
    //                     display: false,
    //                   },
    //                   gridLines: {
    //                     drawBorder: false,
    //                     zeroLineColor: "transparent",
    //                     color: "rgba(255,255,255,0.05)",
    //                   },
    //                 },
    //               ],

    //               xAxes: [
    //                 {
    //                   display: 0,
    //                   barPercentage: 1.6,
    //                   gridLines: {
    //                     drawBorder: false,
    //                     color: "rgba(255,255,255,0.1)",
    //                     zeroLineColor: "transparent",
    //                   },
    //                   ticks: {
    //                     display: false,
    //                   },
    //                 },
    //               ],
    //             },
    //           },
    //         };
    //       }
    //     });
    // },
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.daterange =
      moment().startOf("y").format("MMM") +
      " - " +
      moment().endOf("y").format("MMM YYYY");

    this.selects.date = [moment().startOf("y"), moment().endOf("y")];
    this.getPort();

    //  set default state
    this.tabActive("incoming");
  },
  watch: {
    "selects.date"() {
      if (this.flag !== 'sales') {
        this.daterange =
          moment(this.selects.date[0]).format("MMM") +
          " - " +
          moment(this.selects.date[1]).format("MMM YYYY");
      } else {
        this.daterange = moment(this.selects.date).format("YYYY");
      }

      this.getlandpiedata();
    },
    "selects.port"() {
      this.getlandpiedata();
    },
  },
};
</script>

<style>
.tab-heading {
  color: #000000;
  font-size: 20px;
  font-weight: 600;
}

.text-primary {
  font-weight: 600;
}
</style>
